// The month target on the web (the API's CalendarPlanDto): a gap named by its weekday and time,
// the composer link that fills it, and which days of the grid fall inside the coming window.
// Plan dates are already days on the property's clock, so they are read as calendar dates.
import type { PlanGap } from '@str/api/types';
import { DAYS, addDays, parseIsoDate, toIsoDate } from './format';

/** "Thu 6:30 PM": the weekday of the gap's own date and its time. */
export function gapLabel(gap: PlanGap): string {
  const d = parseIsoDate(gap.date);
  return `${DAYS[(d.getDay() + 6) % 7]} ${gap.time}`;
}

/** The composer, opened on a slot: the idea to start from (when there is one), the day, the time. */
export function createHref(slot: { ideaId?: string | null; date: string; time: string }): string {
  const q = new URLSearchParams();
  if (slot.ideaId) q.set('idea', slot.ideaId);
  q.set('date', slot.date);
  q.set('time', slot.time);
  return `/app/create?${q.toString()}`;
}

/** Today through today + (days - 1): the coming window the target counts. */
export function inWindow(iso: string, todayIso: string, days: number): boolean {
  return iso >= todayIso && iso <= toIsoDate(addDays(parseIsoDate(todayIso), days - 1));
}

/** The time a day is filled at: the one the plan picked for it, else the evening preset. */
export function slotOn(iso: string, gaps: readonly PlanGap[]): string {
  return gaps.find((g) => g.date === iso)?.time ?? '6:30 PM';
}

/** "Thursday, October 15": a day in full, for a control's accessible name. */
export function fullDay(iso: string): string {
  return parseIsoDate(iso).toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  });
}
